// import logo from "./logo.svg";
// import "./App.css";
// import ImportTariff from "./Components/Dashboard/Dashboard";
// import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
// import DetailsView from "./Components/DetailsView/DetailsVeiw";
// import { Provider } from "react-redux";
// import store from "./Components/Redux/Store/Store";
// import Login from "./Components/LoginPage.js/Login";
// import LandingPage from "./Components/LandingPage/LandingPage";
// import { setRedirectToLogin } from "./Components/LoginPage.js/navigationService";
// import React from "react";

// function App() {
//   const apiKey = process.env.REACT_APP_API_KEY;
//   const apiUrl = process.env.REACT_APP_API_URL;
//   const navigate = useNavigate();
//   React.useEffect(() => {
//     setRedirectToLogin(() => () => {
//       navigate("/");
//     });
//   }, [navigate]);
//   return (
//     <BrowserRouter>
//       <Provider store={store}>
//         <Routes>
//           <Route path="/" element={<Login />} />
//           <Route path="/Dashboard" element={<LandingPage />} />
//           {/* <Route path="/" element={<ImportTariff />} /> */}
//           <Route path="/sourcing-compass/" element={<ImportTariff />} />
//           <Route path="/tariff-tool/" element={<ImportTariff />} />
//           <Route path="/tariff-tool" element={<ImportTariff />} />
//           <Route path="*" element={<ImportTariff />} />
//           <Route path="/sourcing-compass-vvf" element={<ImportTariff />} />
//           <Route path="/detail-view" element={<DetailsView />} />
//         </Routes>
//       </Provider>
//     </BrowserRouter>
//   );
// }

// export default App;

// App.js// App.js
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Components/Redux/Store/Store";
import Login from "./Components/LoginPage.js/Login";
import LandingPage from "./Components/LandingPage/LandingPage";
import ImportTariff from "./Components/Dashboard/Dashboard";
import DetailsView from "./Components/DetailsView/DetailsVeiw";
import { setNavigate } from "./Components/LoginPage.js/navigationService";
import BookmarkView from "./Components/BookmarkView/BookmarkView";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import { AuthProvider } from "./Components/LoginPage.js/UserAuthContext";
import MethodologyAssumptionsPage from "./Components/Assumption/Assumption";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./Components/Utils/ScrollToTop";
import Analytics from "./Components/Analytics/Analytics";
function RedirectSetup() {
  const navigate = useNavigate();

  React.useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <AuthProvider>
        <Provider store={store}>
          {/* This component sets up redirect handler */}
          <RedirectSetup />
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <LandingPage />
                </ProtectedRoute>
              }
            />
            {/* <Route path="/Dashboard" element={<LandingPage />} /> */}
            <Route
              path="/bookmark-data"
              element={
                <ProtectedRoute>
                  <BookmarkView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <ProtectedRoute>
                  <Analytics />
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <ImportTariff />
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/sourcing-compass/"
              element={
                <ProtectedRoute>
                  <ImportTariff />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/assumption&methodology"
              element={
                <ProtectedRoute>
                  <MethodologyAssumptionsPage />
                </ProtectedRoute>
              }
            />
            {/* <Route
              path="/tariff-tool/"
              element={
                <ProtectedRoute>
                  <ImportTariff />
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/tariff-tool"
              element={
                <ProtectedRoute>
                  <ImportTariff />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path="/tariff-matrix"
              element={
                <ProtectedRoute>
                  <ImportTariff />
                </ProtectedRoute>
              }
            />
            <Route
              path="/detail-view"
              element={
                <ProtectedRoute>
                  <DetailsView />
                </ProtectedRoute>
              }
            />
            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <ImportTariff />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Provider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
